import type * as Types from '../../../../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveClassroomInvitationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type RemoveClassroomInvitationMutation = { __typename?: 'RootMutationType', removeClassroomInvitation: { __typename?: 'RemoveClassroomInvitationResult', result?: { __typename?: 'ClassroomInvitation', id: string } | null, errors: Array<{ __typename?: 'MutationError', message?: string | null }> } };


export const RemoveClassroomInvitationDocument = gql`
    mutation RemoveClassroomInvitation($id: ID!) {
  removeClassroomInvitation(id: $id) {
    result {
      id
    }
    errors {
      message
    }
  }
}
    `;
export type RemoveClassroomInvitationMutationFn = Apollo.MutationFunction<RemoveClassroomInvitationMutation, RemoveClassroomInvitationMutationVariables>;

/**
 * __useRemoveClassroomInvitationMutation__
 *
 * To run a mutation, you first call `useRemoveClassroomInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveClassroomInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeClassroomInvitationMutation, { data, loading, error }] = useRemoveClassroomInvitationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveClassroomInvitationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveClassroomInvitationMutation, RemoveClassroomInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveClassroomInvitationMutation, RemoveClassroomInvitationMutationVariables>(RemoveClassroomInvitationDocument, options);
      }
export type RemoveClassroomInvitationMutationHookResult = ReturnType<typeof useRemoveClassroomInvitationMutation>;
export type RemoveClassroomInvitationMutationResult = Apollo.MutationResult<RemoveClassroomInvitationMutation>;
export type RemoveClassroomInvitationMutationOptions = Apollo.BaseMutationOptions<RemoveClassroomInvitationMutation, RemoveClassroomInvitationMutationVariables>;